import script from "./TaglineDivider.vue?vue&type=script&setup=true&lang=js"
export * from "./TaglineDivider.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__